module.exports = __webpack_public_path__ + "static/media/ax.1313bc24.svg";